export default "__VITE_ASSET__BXraZVV0__"